/**
 * @copyright Copyright (c) 2016, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:dbarreto@pacificbiosciences.com">David Barreto</a>
 */

import {commonTranslations} from "./common"

export const runDesignTranslations = {
    title: "Runs",
    link: commonTranslations.newRunDesign,
    list: {
        column: "Column",
        error: commonTranslations.error,
        importError: "Import of \"{file}\" Failed",
        importRunDesign: "Import Run Design",
        newRunDesign: commonTranslations.newRunDesign,
        ok: commonTranslations.ok,
        row: "Row"
    },
    editor: {
        newTitle: commonTranslations.newRunDesign,
        editTitle: "Edit Run Design",
        delete: commonTranslations.delete,
        cancel: commonTranslations.cancel,
        viewSummary: "View Run Design",
        autoAnalysis: "Auto Analysis",
        save: commonTranslations.save,
        runInfo: {
            title: "Run Information",
            experimentId: "Experiment Id",
            experimentName: "Experiment Name",
            runComments: "Run Comments",
            runName: commonTranslations.runName
        },
        consumables: {
            title: "Run Reagents / Consumables",
            barcodeScanMessage: "Click the Barcode link to scan your a barcode then click OK to continue.",
            enzymeTubes: "{quantity} OS enzyme {quantity, plural, =1 {tube} other {tubes}}",
            mineralOilTubes: "{quantity} mineral oil {quantity, plural, =1 {tube} other {tubes}}",
            mixingPlates: "{quantity} mixing {quantity, plural, =1 {plate} other {plates}}",
            reagentPlates: "{quantity} sequencing reagent {quantity, plural, =1 {plate} other {plates}}",
            samplePlates: "{quantity} sample {quantity, plural, =1 {plate} other {plates}}",
            smrtCellsStandard: "{quantity} SMRT {quantity, plural, =1 {Cell} other {Cells}}",
            smrtCellsLR: "{quantity} SMRT {quantity, plural, =1 {Cell} other {Cells}} LR",
            tipBoxes: "{quantity} {quantity, plural, =1 {box} other {boxes}} of tips"
        },
        sampleInfo: {
            title: "Sample Information",
            advancedOptions: "Advanced Options",
            bindingKit: "Binding Kit",
            collectionsPerSMRTCell: "Collections per SMRT Cell",
            copy: commonTranslations.copy,
            create: "Create",
            delete: commonTranslations.delete,
            dnaControlComplex: "DNA Control Complex",
            immobilizationTime: "Immobilization Time (hours)",
            extensionTime: "Pre-Extension Time (hours)",
            insertSize: "Insert Size (bp)",
            movieTime: "Movie Time per SMRT Cell (hours)",
            no: "No",
            off: commonTranslations.off,
            on: commonTranslations.on,
            sampleComment: "Sample Comment",
            sampleName: commonTranslations.sampleName,
            sampleReuse: "Reuse Sample",
            sampleTitle: "SAMPLE {sampleNumber}: {sampleName}, {wellName}, {movieTime} hour movie, {insertSize} bp insert",
            sampleWell: "Sample Well",
            sequencingKit: "Sequencing Kit",
            smrtCellExtendedUse: "SMRT Cell Extended Use",
            templatePrepKit: "Template Prep Kit",
            washKit: "Extended Use Kit",
            yes: "Yes"
        }
    },
    summary: {
        title: "Summary of Run Design",
        cancel: commonTranslations.cancel,
        edit: commonTranslations.edit,
        view: commonTranslations.view
    }
}
